import React from "react";
import styles from "./Loader.module.css";
import LoaderCircle from "../../../assets/loader.svg";

export default function Loader() {
	return <img className={styles.loader} src={LoaderCircle} alt="" />;
}
